import { bankpay_consumer_token, avatarUrl } from './constants';
import getSymbolFromCurrency from 'currency-symbol-map';

export const setLocalStorageData = (key, data) => {
  localStorage.setItem(key, data);
};

export const getLocalStorageData = (key, type) => {
  let value;
  if (type === 'string') value = localStorage.getItem(key);
  else if (type === 'object') value = JSON.parse(localStorage.getItem(key));
  return value;
};
export const getUserToken = () => localStorage.getItem(bankpay_consumer_token);

export const logOut = () => localStorage.clear();

export const getAvatar = (data) =>
  `${avatarUrl}?background=${data?.background}&name=${data?.name}&color=ffffff&rounded=true&font-size=0.4`;

export const convertCurrency = (currency) => getSymbolFromCurrency(currency);
